import { ComponentType } from "react";

import { ILLFTemplateRenderer, LiteListFrameTemplateProps } from "@multiweb/customization";
import { GRID_PARTICIPANTS_ROLE_USERS_TEMPLATE_RENDERER_KEY } from "../../../constants";
import { RoleUsersTemplate } from "./RoleUsersTemplate";

export class RoleUsersTemplateRenderer implements ILLFTemplateRenderer {
    public readonly key: string = GRID_PARTICIPANTS_ROLE_USERS_TEMPLATE_RENDERER_KEY;

    public get component(): ComponentType<LiteListFrameTemplateProps> {
        return RoleUsersTemplate;
    }
}
